import React from "react";
import { useLang } from '../contexts/LanguageContext';
import { Container } from "react-bootstrap";
import NavbarHome from '../components/NavbarIndex';
import Footer from "../components/Footer";


export default function TermsOfUse() {

  /* Variable de traducción */
  const { t } = useLang();

  return (
    <div>
      <NavbarHome static_page="true" />
      <Container>
        <h1>{t("TERMS_OF_USE_TITLE")}</h1>
        <p className="text-end">{t("TERMS_DATE_DESC")}</p>
        <p  style={{ textAlign: "justify" }}>{t("TERMS_OF_USE_RESUME")}</p>
        <p style={{ textAlign: "justify" }} dangerouslySetInnerHTML={{__html: t("TERMS_OF_USE_TEXT")}}></p>
      </Container>
      <Footer />
    </div>
  );
}
